import React from "react";
import clsx from "clsx";
import { Row, Col } from "react-bootstrap";

import { ReactComponent as AlertIcon } from "static/images/alert-round.svg";
import styles from "../filter.module.scss";

const NumericRangeInputErrorMessage = () => {
	return (
		<Row>
			<Col
				sm={{ offset: 3, span: 9 }}
				className={clsx("errorMessage mt-2", styles.errorContainer)}
			>
				<AlertIcon width="27" />
				<span>
					The range "To" should be higher than the lower range "From"
				</span>
			</Col>
		</Row>
	);
};

export default NumericRangeInputErrorMessage;
